// extracted by mini-css-extract-plugin
export var wrapper = "ErrorModal-module--wrapper--c0e9a";
export var text = "ErrorModal-module--text--eb237";
export var contact = "ErrorModal-module--contact--45091";
export var link = "ErrorModal-module--link--ab27e";
export var icon = "ErrorModal-module--icon--a7cb3";